import { TaxType } from '@viewbid/ts-angular-client';

export enum TypeEnum {
    BUSINESS = 'BUSINESS',
    CHARITY = 'CHARITY',
}

export interface NotificationPreferencesFormData {
    preferences: string;
}

export interface CreateBusinessAccountFormData {
    type?: TypeEnum;
    name: string;
    businessNumber: string;
    representativeFullName: string;
    phoneNumber: string;
    phoneNumberExt: string;
    address1: string;
    address2: string;
    country: string;
    province: string;
    city: string;
    postalCode: string;
    taxType?: TaxType;
    buzzer: string;
}

export interface CreateUserAccountFormData {
    userName: string;
    firstname: string;
    lastname: string;
    phoneNumber: string;
    phoneNumberExt: string;
    address1: string;
    address2: string;
    country: string;
    province: string;
    city: string;
    postalCode: string;
    buzzer: string;
    businessSelected: boolean;
    charitySelected: boolean;
}

export interface CreateUserAccountPacket {
    userName: string;
    firstname: string;
    lastname: string;
    phoneNumber: string;
    phoneNumberExt: string;
    address1: string;
    address2: string;
    country: string;
    province: string;
    city: string;
    postalCode: string;
    preferences: string;
    buzzer: string;
    businessSelected: boolean;
    charitySelected: boolean;
    organization?: CreateBusinessAccountFormData | null;
}
